import { Injectable, inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';

import { POIService } from '../poi.service';
import { SocketService } from '../socket.service';
import { TenantService } from '../tenant.service';
import { BaseSocketEventHandler } from './base-socket-event-handler';

interface POICategoriesUpdatedSocketEvent {
    eventDtoType: 'PoiCategoriesUpdated';
}

@Injectable({ providedIn: 'root' })
export class POICategoriesUpdatedSocketEventHandler extends BaseSocketEventHandler<POICategoriesUpdatedSocketEvent> {
    private tenantService = inject(TenantService);
    private poiService = inject(POIService);

    protected eventDtoType(): string {
        return 'PoiCategoriesUpdated';
    }

    protected handleEvent = async (_: POICategoriesUpdatedSocketEvent): Promise<void> => {
        await this.tenantService.refreshConfig();
        await firstValueFrom(this.poiService.refreshPOIs());
    };
}
